import type { ReactNode } from 'react';
import { t } from '../i18n/index.js';
import { BrandLogo } from './Brand.js';
import { ThemeToggle } from './ThemeToggle.js';

/**
 * Signed-out layout for both apps: a centred card on a two-tone gradient, the brand block on
 * top (company logo, product tag) and only the theme toggle in the corner.
 */
export function AuthShell({ children, subtitle }: { children: ReactNode; subtitle?: string }) {
  return (
    <div className="auth-shell">
      <div className="auth-corner">
        <ThemeToggle />
      </div>
      <main className="auth-main">
        <div className="auth-card">
          <div className="brand-block">
            <div className="brand-logo-wrap">
              <BrandLogo />
            </div>
            <div className="brand-line">
              <span className="brand-tag">{t('auth_tag')}</span>
              {subtitle && <span className="brand-sub">{subtitle}</span>}
            </div>
          </div>
          {children}
        </div>
        <p className="auth-foot muted">{t('auth_foot')}</p>
      </main>
    </div>
  );
}

/** "1 Password · 2 Passkey" step indicator for the admin sign-in. */
export function Steps({ current, labels }: { current: number; labels: string[] }) {
  return (
    <ol className="steps" aria-label={t('auth_steps')}>
      {labels.map((label, i) => {
        const n = i + 1;
        const state = n < current ? 'done' : n === current ? 'active' : 'todo';
        return (
          <li
            key={label}
            className={`step ${state}`}
            aria-current={n === current ? 'step' : undefined}
          >
            <span className="step-num" aria-hidden="true">
              {n}
            </span>
            <span className="step-label">{label}</span>
          </li>
        );
      })}
    </ol>
  );
}
